import type { SVGProps } from "react";

export default function PDFIcon(props: Readonly<SVGProps<SVGSVGElement>>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
      fill="none"
      {...props}
    >
      <path
        d="M3.97345 1.05273C3.23661 1.05273 2.63135 1.69583 2.63135 2.47872V17.5215C2.63135 18.3044 3.23661 18.9475 3.97345 18.9475H16.026C16.7629 18.9475 17.3681 18.3044 17.3681 17.5215V6.72872L12.3945 1.05273H3.97345Z"
        fill="#A5C9F6"
      />
      <path
        d="M17.368 6.75659V7.0362H13.9996C13.9996 7.0362 12.3417 6.67271 12.3943 5.16284C12.3943 5.16284 12.4469 6.75659 13.9732 6.75659H17.368Z"
        fill="#0D1A6B"
      />
      <path
        opacity="0.5"
        d="M12.3945 1.05273V5.13497C12.3945 5.6103 12.684 6.75668 13.9998 6.75668H17.3682L12.3945 1.05273Z"
        fill="black"
      />
      <path
        d="M6.23682 15.408H5.20557V16.6892C5.20557 16.8142 5.11182 16.908 4.95557 16.908C4.83057 16.908 4.73682 16.8142 4.73682 16.6892V13.5017C4.73682 13.3142 4.89307 13.158 5.08057 13.158H6.23682C6.98682 13.158 7.42432 13.6892 7.42432 14.283C7.42432 14.908 6.98682 15.408 6.23682 15.408ZM6.20557 13.5642H5.20557V15.0017H6.20557C6.64307 15.0017 6.95557 14.7205 6.95557 14.283C6.95557 13.8455 6.64307 13.5642 6.20557 13.5642ZM9.45557 16.908H8.51807C8.33057 16.908 8.17432 16.7517 8.17432 16.5642V13.5017C8.17432 13.3142 8.33057 13.158 8.51807 13.158H9.45557C10.6118 13.158 11.3931 13.9705 11.3931 15.033C11.3931 16.0955 10.6431 16.908 9.45557 16.908ZM9.45557 13.5642H8.64307V16.4705H9.45557C10.3618 16.4705 10.8931 15.8142 10.8931 15.0017C10.9243 14.2205 10.3931 13.5642 9.45557 13.5642ZM14.5493 13.5642H12.7368V14.783H14.5181C14.6431 14.783 14.7056 14.8767 14.7056 15.0017C14.7056 15.1267 14.6118 15.1892 14.5181 15.1892H12.7368V16.6892C12.7368 16.8142 12.6431 16.908 12.4868 16.908C12.3618 16.908 12.2681 16.8142 12.2681 16.6892V13.5017C12.2681 13.3142 12.4243 13.158 12.6118 13.158H14.5493C14.6743 13.158 14.7368 13.2517 14.7368 13.3767C14.7681 13.4705 14.6743 13.5642 14.5493 13.5642Z"
        fill="black"
      />
    </svg>
  );
}
